module.exports = __webpack_public_path__ + "static/media/retreat-03.2d4c2aa3.jpg";